import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var SunMin = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M22 10.933c-6.344 0-11.487 5.143-11.487 11.487S15.656 33.907 22 33.907s11.487-5.143 11.487-11.487S28.344 10.933 22 10.933ZM8.365 22.42c0-7.53 6.104-13.636 13.635-13.636 7.53 0 13.635 6.105 13.635 13.636 0 7.53-6.104 13.635-13.635 13.635-7.53 0-13.635-6.104-13.635-13.635ZM0 22.42c0-.593.48-1.074 1.074-1.074h2.664a1.074 1.074 0 1 1 0 2.148H1.074C.481 23.494 0 23.014 0 22.42ZM9.84 34.58c.42.42.42 1.1 0 1.519l-1.876 1.876a1.074 1.074 0 0 1-1.52-1.52l1.877-1.875c.42-.42 1.1-.42 1.52 0ZM22 39.607c.593 0 1.074.481 1.074 1.075v2.664a1.074 1.074 0 1 1-2.148 0v-2.664c0-.594.48-1.075 1.074-1.075ZM34.16 34.58c.42-.42 1.1-.42 1.519 0l1.876 1.876a1.074 1.074 0 0 1-1.519 1.52l-1.876-1.877c-.42-.42-.42-1.1 0-1.52ZM39.188 22.42c0-.593.48-1.074 1.074-1.074h2.664a1.074 1.074 0 1 1 0 2.148h-2.664c-.594 0-1.075-.48-1.075-1.074ZM22 .42c.593 0 1.074.48 1.074 1.074v2.664a1.074 1.074 0 1 1-2.148 0V1.494c0-.593.48-1.074 1.074-1.074ZM6.445 6.865c.42-.42 1.1-.42 1.519 0L9.84 8.74a1.074 1.074 0 0 1-1.519 1.52L6.445 8.383c-.42-.42-.42-1.1 0-1.52ZM37.555 6.865c.42.42.42 1.1 0 1.519L35.68 10.26a1.074 1.074 0 0 1-1.52-1.519l1.877-1.876c.42-.42 1.1-.42 1.52 0Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
SunMin.displayName = 'SunMin';
SunMin.defaultProps = {
  'aria-label': 'SunMin'
};
export default SunMin;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/SunMin.js
// module id = 3929
// module chunks = 11